<template>
  <div class="max-h-[98vh]" :key="pageTitle">
    <PageTitleVue
      :sub-title="subTitle"
      :key="subTitle"
    >
      {{ pageTitle }}

      <!-- go back button -->
      <template #action>
        <div
          class="cursor-pointer text-gray-400"
          :key="backPage"
          v-if="
            dataEvent.state.componentActive.__name !== 'SectorsCards' &&
            dataEvent.state.componentActive.__name !== 'SectorForm' &&
            dataEvent.state.componentActive.__name !== 'SectorFormUpdate'
          "
        >
          <p class="flex" @click="setBackComponent()">
            <component
              :is="PhArrowLeft"
              class="w-7 h-7 p-1"
            />
            <p class="my-auto">voltar</p>
          </p>
        </div>
      </template>

      <template #b-action>
        <div v-if="buttonActive">
          <Create
            :icon="PhFactory"
            :label="'Novo Evento'"
            :width-maximus="true"
            @click="setComponentActive(SectorForm)"
            v-if="dataEvent.state.componentActive.__name == 'SectorsCards'"
          />

          <Create
            :icon="PhArrowLeft"
            :label="'Ver todos'"
            :width-maximus-plus="true"
            @click="setComponentActive(SectorsCards)"
            v-else-if="dataEvent.state.componentActive.__name == 'SectorForm'"
          />

          <Create
            :icon="PhArrowLeft"
            :label="'Voltar aos eventos'"
            :width-maximus-plus="true"
            @click="setComponentActive(SectorsCards)"
            v-else-if="dataEvent.state.componentActive.__name == 'SectorFormUpdate'"
          />
        </div>
      </template>
    </PageTitleVue>

    <Transition mode="out-in">
      <div :key="componentActive" class="overflow-hidden">
        <keep-alive>
          <component :is="componentActive"/>
        </keep-alive>
      </div>
    </Transition>
  </div>
</template>

<script setup>
import PageTitleVue from '@/components/Titles/PageTitle.vue'
import SectorsCards from './layout/pages/SectorsCards.vue'
import ExtinguisherService from './service/event.service'
import Create from '@/components/Buttons/Create.vue'
import SectorForm from './layout/SectorForm.vue'
import { PhArrowLeft, PhFactory } from '@phosphor-icons/vue'
import { onBeforeMount, computed, markRaw } from 'vue'
import { storeApp } from '@/store'
import { dataEvent } from './store'

import EventService from './service/event.service'

const componentActive = computed(() => markRaw(dataEvent.getters.getActiveComponent))
const buttonActive = computed(() => dataEvent.getters.getIfButtonActive)
const subTitle = computed(() => dataEvent.getters.getPageSubTitle)
const backPage = computed(() => dataEvent.getters.backToComponent)

const pageTitle = computed(() => {
  if (dataEvent.state.componentActive.__name == 'SectorsCards') {
    dataEvent.dispatch('setPageTitle', 'EVENTOS')
    dataEvent.dispatch('setPageSubTitle', 'Gerencie todos os seus eventos')
  }

  if (dataEvent.state.componentActive.__name == 'SectorForm') {
    dataEvent.dispatch('setPageTitle', 'NOVO EVENTO')
    dataEvent.dispatch('setPageSubTitle', 'Adicione um novo evento')
  }

  if (dataEvent.state.componentActive.__name == 'SectorFormUpdate') {
    dataEvent.dispatch('setPageTitle', 'ALTERAR EVENTO')
    dataEvent.dispatch('setPageSubTitle', 'Altere os dados deste evento')
  }

  return dataEvent.getters.getTitle
})

// eventos
async function getEvents () {
  await EventService.getEvents()
    .then((res) => {
      dataEvent.dispatch('setAllEvents', res.data)
    })
    .catch((err) => {
      console.log(err)
    })
}

async function comboFighters () {
  await EventService.getFighters()
    .then((res) => {
      dataEvent.dispatch('setAllFighters', res.data)
    })
    .catch((err) => {
      console.log(err)
    })
}

onBeforeMount(async () => {
  storeApp.state.loading = true
  dataEvent.dispatch('setComponentActive', markRaw(SectorsCards))
  dataEvent.dispatch('setBackComponent', 'SectorsCards')
  await getEvents()
  Promise.all([
    comboFighters()
  ])
  storeApp.state.loading = false
})

function setComponentActive (value) {
  dataEvent.dispatch('resetForm')
  dataEvent.dispatch('setComponentActive', markRaw(value))
}
</script>

<style lang="scss">
::v-deep .v-enter-from,
::v-deep .v-leave-to {
  transform: translate(50px);
  opacity: 0;
}

::v-deep .v-enter-active,
::v-deep .v-leave-active {
  transition: all 0.3s;
}
</style>
